import React, { useEffect, useState } from "react";
import { Progress, Spin } from "antd";

const AnalyticsCacheBuildingLoader = ({
  message = "Analytics dashboard is still loading from PostHog. Retry this request shortly.",
  attempt = 1,
  maxAttempts = 40,
  retryAfterSeconds = 15,
  cacheStatus = "building",
}) => {
  const [countdown, setCountdown] = useState(retryAfterSeconds);

  useEffect(() => {
    setCountdown(retryAfterSeconds);
    const id = setInterval(() => {
      setCountdown((current) => (current <= 1 ? retryAfterSeconds : current - 1));
    }, 1000);
    return () => clearInterval(id);
  }, [attempt, retryAfterSeconds]);

  const waitProgress = Math.round(
    ((retryAfterSeconds - countdown) / Math.max(retryAfterSeconds, 1)) * 100,
  );
  const overallProgress = Math.min(
    95,
    Math.round((attempt / Math.max(maxAttempts, 1)) * 100),
  );

  return (
    <div className="analytics-cache-building">
      <div className="analytics-cache-building__icon">
        <Spin size="large" />
      </div>
      <h3 className="analytics-cache-building__title">Loading analytics from PostHog</h3>
      <p className="analytics-cache-building__message">{message}</p>

      <div className="analytics-cache-building__block">
        <div className="analytics-cache-building__row">
          <span>Next retry</span>
          <span>{countdown}s</span>
        </div>
        <Progress
          percent={waitProgress}
          status="active"
          showInfo={false}
          strokeColor={{ from: "#6366f1", to: "#818cf8" }}
          trailColor="#1e293b"
        />
      </div>

      <div className="analytics-cache-building__block">
        <div className="analytics-cache-building__row">
          <span>Building cache</span>
          <span>
            Attempt {attempt}
            {maxAttempts ? ` / ${maxAttempts}` : ""}
          </span>
        </div>
        <Progress
          percent={overallProgress}
          status="active"
          showInfo={false}
          strokeColor={{ from: "#22c55e", to: "#4ade80" }}
          trailColor="#1e293b"
        />
      </div>

      {cacheStatus && (
        <p className="analytics-cache-building__cache">
          <i className="fa-solid fa-database" aria-hidden="true" />
          Cache status: <strong>{cacheStatus}</strong>
        </p>
      )}
    </div>
  );
};

export default AnalyticsCacheBuildingLoader;
